import AppShell from "./AppShell";
import { getApp } from "@/lib/apps";

const Fullynq = () => <AppShell app={getApp("fullynq")} />;

export default Fullynq;
